(function($) {

    $(function() {
        var body = $('body');

        if(body.hasClass('single-database-viewer')) {

            let postId = $('#database-post-id').val();
            let modalFilter = $('#modal-filters');
            var filterParams = [];
            var userSavedFilters = [];

            var hashVars = [], hash;
            var url = location.href;
            var q = url.split('#')[1];

            if(q != undefined) {
                q = q.split('&');

                for(var i = 0; i < q.length; i++) {
                    hash = q[i].split('=');
                    hashVars[hash[0]] = decodeURIComponent(hash[1]);
                }

                Object.keys(hashVars).forEach(key => {
                    filterParams.push({
                        columnLetter: key,
                        values: [hashVars[key]]
                    });

                });

            }
            console.log(filterParams);

            renderLastModifiedDate();

            var dataTable = $('#dataviewer-table').DataTable({
                processing: true,
                serverSide: true,
                ajax: {
                    url: drturner_params.ajax_url,
                    type: 'POST',
                    data: function(d) {
                        d.action = 'database_viewer';
                        d.postId = postId;
                        d.filterParams = filterParams;
                    },
                    dataSrc: function (json) {
                        return json.data.data;
                    },
                    dataFilter: function(data) {
                        var json = jQuery.parseJSON( data );
                        json.draw = json.data.draw;
                        json.recordsTotal = json.data.recordsTotal;
                        json.recordsFiltered = json.data.recordsFiltered;

                        return JSON.stringify( json );
                    }
                },
                columnDefs: [
                    {
                        searchable: false,
                        orderable: false,
                        targets: 0
                    },
                ],
                //f - filter
                dom: '<"table-header-toolbar"p<"middle-comp"i>l><r><t><"table-footer-toolbar"pi>',
                info: true,
                infoCallback: function(settings, start, end, max, total, pre) {
                    let text = `Showing ${start} to ${end} - ${total} Total Records`;
                    return text;
                },
                language: {
                    lengthMenu: 'Items per page: _MENU_'
                },
                lengthMenu: [[50, 100, 200, -1], [50, 100, 200, 'All']]
            });

            $.ajax({
                url: drturner_params.ajax_url,
                type : 'post',
                data: {
                    action: 'database_filters',
                    postId: postId
                },
                success: function(resp) {
                    // console.log(Object.keys(resp.data.availableFilters).length);
                    let columnLetters = Object.keys(resp.data.availableFilters);

                    if(columnLetters.length) {
                        let modalBody = modalFilter.find('.filters-containers');

                        let modalRow = columnLetters.map(letter => {
                            let column = resp.data.availableFilters[letter];


                            let filterField = '';
                            if(column.dataType != 'number') {
                                if(column.filterType == 'dynamic') {
                                    let selectOptions = Object.keys(column.filterValues).map(key => {
                                        let optionSelected = '';
                                        // console.log(column.filterValues[key].toLowerCase());
                                        // console.log(hashVars[letter]);
                                        if(hashVars[letter] && column.filterValues[key].toLowerCase() == hashVars[letter].toLowerCase()) {
                                            optionSelected = 'selected';
                                        }
                                        return `<option value="${column.filterValues[key]}" ${optionSelected}>${column.filterValues[key]}</option>`;
                                    });

                                    filterField = `<select multiple class="select-multiple">${selectOptions.join('')}</select>`;
                                }
                                else {
                                    let filterValue = '';
                                    if(hashVars[letter]) {
                                        filterValue = hashVars[letter];
                                    }
                                    filterField = `<input type="text" class="input-filter" value="${filterValue}">`;
                                }
                            }
                            else {
                                let filterValue = '';
                                if(hashVars[letter]) {
                                    filterValue = hashVars[letter];
                                }

                                filterField = `<input type="text" class="input-filter" value="${filterValue}">`;
                            }

                            let selectOperator = `<select class="select select-operator">
                                                    <option value="">--select--</option>
                                                    <option value="<="><=</option>
                                                    <option value=">=">>=</option>
                                                    <option value="=">=</option>
                                                </select>`;

                            let colField = `<div class="col-3 col-fields">${filterField}</div>`;
                            let colOperator = (column.dataType != 'number')? '' : `<div class="col-3 col-fields">${selectOperator}</div>`;
                            let colLabel = `<div class="col-4 col-label">${column.title}:</div>`;

                            return `<div class="row" data-column-letter="${letter}" 
                                        data-data-type="${column.dataType}" data-filter-type="${column.filterType}">
                                            ${colLabel}${colOperator}${colField}
                                        </div>`;
                        });

                        modalBody.html(modalRow);
                    }

                    if(resp.data.savedFiltersList) {
                        let savedFiltersSelect = modalFilter.find("#savedFiltersSelect");

                        let {savedFilters} = resp.data.savedFiltersList;
                        userSavedFilters = savedFilters;

                        let selectOptions = savedFilters.map(obj => {
                            return `<option value="${obj.filterName}">${obj.filterName}</option>`;
                        });

                        savedFiltersSelect.html(`<option value=""></option>${selectOptions.join('')}`);
                    }

                }
            });

            $('.middle-comp').append('<a class="button btn--small filter-btn" data-toggle="modal" data-target="#modal-filters">Filter data <span class="la la-sliders btn-icon"></span></a>');

            modalFilter.on('change', '#savedFiltersSelect', function(ev) {
                let filterSelect = $(ev.target);
                let choosenFilter = userSavedFilters.filter(obj => obj.filterName == filterSelect.val());

                clearFiltersParams();

                if(choosenFilter.length) {
                    choosenFilter[0].filtersParams.forEach(obj => {
                        let filterRow = $(modalFilter.find(`.row[data-column-letter="${obj.columnLetter}"]`));
                        if(obj.columnLetter == 'general_search') {
                            let generalSearch = $(modalFilter.find('#generalSearch'));
                            if(generalSearch.length) {
                                generalSearch.val(obj.values);
                            }
                        } else if(obj.operator) {
                            let selectOperator = $(filterRow.find('.select-operator'));
                            selectOperator.val(obj.operator);

                            let inputFilter = $(filterRow.find('.input-filter'));
                            inputFilter.val(obj.values);
                        }
                        else if(typeof obj.values == 'object') {
                            let select = $(filterRow.find('.select-multiple'));
                            select.val(obj.values);
                        }
                        else if(typeof obj.values == 'string') {
                            let inputFilter = $(filterRow.find('.input-filter'));
                            inputFilter.val(obj.values);
                        }
                    });
                }

            });

            modalFilter.on('click', '#applyBtn', function() {
                getFilterParams();

                dataTable.draw();
                modalFilter.modal('toggle');
            });

            modalFilter.on('click', '#resetBtn', function(ev) {
                ev.preventDefault();

                let rows = modalFilter.find('.row[data-column-letter]');
                modalFilter.find('#generalSearch').val('');

                let savedFilterSelect = modalFilter.find('.saved-filter-select');
                if(savedFilterSelect.length) {
                    savedFilterSelect.val('');
                }

                rows.each((i, row) => {
                    var rowObj = $(row);
                    var columnLetter = rowObj.data('column-letter');
                    var columnDataType = rowObj.data('data-type');
                    var columnFilterType = rowObj.data('filter-type');

                    if(columnDataType != 'number') {
                        if(columnFilterType == 'dynamic') {
                            rowObj.find('select').val('');
                        }
                        else {
                            rowObj.find('input').val('');
                        }
                    }
                    else {
                        rowObj.find('input').val('');
                        rowObj.find('select').val('');
                    }
                });
            });

            modalFilter.on('click', '#saveFilterBtn', function(ev) {
                getFilterParams();
                let saveFilterName = $(modalFilter.find("#saveFilterName"));

                saveFilterName.removeClass('error');

                if(!saveFilterName.val().trim()) {
                    saveFilterName.addClass('error');

                    return false;
                }
                if(!filterParams.length) {
                    return false;
                }

                var saveBtn = $(ev.target);
                if(saveBtn.hasClass('disable')) {
                    return false;
                }
                saveBtn.addClass('disable');

                $.ajax({
                    url: drturner_params.ajax_url,
                    type : 'post',
                    data: {
                        action: 'save_database_filters',
                        postId: postId,
                        filterParams,
                        filterName: saveFilterName.val().trim()
                    },
                    success: function(resp) {
                        // console.log(resp.data[0].savedFilters);
                        let savedFiltersSelect = modalFilter.find("#savedFiltersSelect");
                        let {savedFilters} = resp.data[0];
                        userSavedFilters = savedFilters;

                        let selectOptions = savedFilters.map(obj => {
                            return `<option value="${obj.filterName}">${obj.filterName}</option>`;
                        });

                        savedFiltersSelect.html(`<option value=""></option>${selectOptions.join('')}`);
                        saveFilterName.val('');
                    },
                    complete: function() {
                        saveBtn.removeClass('disable');
                    }
                });
            });

            body.on('click', '.modal-comments .saveBtn', function(ev) {
                ev.preventDefault();
                var saveBtn = $(ev.target);

                if(saveBtn.hasClass('disable')) {
                    return false;
                }

                var modal = saveBtn.parents('.modal-comments');
                var commentInput = modal.find('.comment-input');
                var commentsView = modal.find('.existing-comments-view');

                saveBtn.addClass('disable');

                $.ajax({
                    url: drturner_params.ajax_url,
                    type: 'post',
                    data: {
                        action: 'save_comment',
                        comment: commentInput.val().trim(),
                        rowId: modal.data('row-id'),
                        columnLetter: modal.data('column-letter'),
                        postId: postId
                    },
                    success: function(resp) {
                        let {data} = resp;

                        commentsView.html(data);
                        commentsView[0].scrollTop = commentsView[0].scrollHeight;
                        commentInput.val('');

                        let modalTriggerIcon = $('a.comment-btn[data-target="#comment-modal-'+modal.data('row-id')+'"] i');

                        if(modalTriggerIcon.hasClass('fa-sticky-note-o')) {
                            modalTriggerIcon.removeClass('fa-sticky-note-o').addClass('fa-sticky-note');
                        }
                    },
                    complete: function() {
                        saveBtn.removeClass('disable');
                    }
                });

            });

            $('.export-btn').on('click', function(ev) {
                ev.preventDefault();
                var btn = $(this);

                if(btn.hasClass('disable')) {
                   return false;
                }

                btn.addClass('disable');
                getFilterParams();
                console.log('filterParams: ', filterParams);

                $.ajax({
                    url: drturner_params.ajax_url,
                    type: 'post',
                    data: {
                        action: 'download_database',
                        postId: postId,
                        format: btn.data('format'),
                        filterParams
                    },
                    success: function(resp) {
                        let {data} = resp;

                        if(data.url) {
                            var a = document.createElement('a');
                            a.href = data.url;
                            a.download = data.filename;
                            document.body.append(a);
                            a.click();
                            a.remove();
                        }
                    },
                    complete: function() {
                        btn.removeClass('disable');
                    }
                });


            });

            function getFilterParams() {
                let rows = modalFilter.find('.row[data-column-letter]');
                filterParams = [];

                let generalSearch = modalFilter.find('#generalSearch');
                if(generalSearch.val()) {
                    filterParams.push({
                        columnLetter: 'general_search',
                        values: generalSearch.val().trim()
                    });
                }

                rows.each((i, row) => {
                    var rowObj = $(row);
                    var columnLetter = rowObj.data('column-letter');
                    var columnDataType = rowObj.data('data-type');
                    var columnFilterType = rowObj.data('filter-type');

                    if(columnDataType != 'number') {
                        if(columnFilterType == 'dynamic') {
                            let selects = rowObj.find('select');
                            // console.log(selects);
                            selects.each((index, select) => {
                                let obj = $(select);
                                let values = obj.val();

                                if(values) {
                                    filterParams.push({
                                        columnLetter,
                                        values
                                    });
                                }
                            });
                        }
                        else {
                            let input = rowObj.find('input');
                            let value = $(input).val().trim();

                            if(value) {
                                filterParams.push({
                                    columnLetter,
                                    values: value
                                });
                            }
                        }
                    }
                    else {
                        let input = rowObj.find('input');
                        let value = $(input).val().trim();
                        let select = $(rowObj.find('select'));

                        let operatorValue = (!select.val())? '=' : select.val();

                        if(value) {
                            filterParams.push({
                                columnLetter,
                                operator: operatorValue,
                                values: value
                            });
                        }
                    }
                });
            }

            function clearFiltersParams() {
                let rows = modalFilter.find('.row[data-column-letter]');
                rows.each((i, row) => {
                    var rowObj = $(row);
                    var columnLetter = rowObj.data('column-letter');
                    var columnDataType = rowObj.data('data-type');
                    var columnFilterType = rowObj.data('filter-type');

                    if(columnDataType != 'number') {
                        if(columnFilterType == 'dynamic') {
                            let selects = $(rowObj.find('select'));
                            selects.val('');
                        }
                        else {
                            let input = $(rowObj.find('input'));
                            input.val('');
                        }
                    }
                    else {
                        let input = $(rowObj.find('input'));
                        input.val('');
                        let select = $(rowObj.find('select'));
                        select.val('');
                    }
                });
            }

            function renderLastModifiedDate() {
                let lastModifiedDate = $("#lastModifiedDate");
                if(lastModifiedDate.length) {
                    let updatedDate = lastModifiedDate.data('updated-date');
                    if(updatedDate) {
                        lastModifiedDate.text(moment(updatedDate).format('MMM D, YYYY HH:mm:ss A'));
                    }
                }
            }
        }
    });
})(jQuery);
